import { render, staticRenderFns } from "./ClampedTriggerTooltip.vue?vue&type=template&id=55f72ddc&"
import script from "./ClampedTriggerTooltip.vue?vue&type=script&lang=ts&"
export * from "./ClampedTriggerTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports